import { peek, selector } from 'lib/selectors'
import { StateInterface } from 'types/state'

const education = (state: StateInterface) => state.education
export const educationsListSelector = selector(education, peek('educationsList'))
export const educationSelector = selector(education, peek('education'))
